import OverlayTips from "../../../../js/tips/OverlayTips";

function UserListPageOverlayTipsManager(config)
{
    PageOverlayTipsManager.call(this);
    this.config = config;
}

UserListPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {

    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add(this._createGetElementIfAccountSettingSelectedFunction($("#userListTableHeaderCell_filterCell").find(".userList_accountEnabledFilter-label")), {
            messageKey: "userlist.tips.show_disabled",
            direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
            anchor: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 20,
            offsetY: 20
        });

        this.add(function() {
            var $tabAccountSettings = $("#tabAccountSettings");
            if ($tabAccountSettings.length == 0 || $tabAccountSettings.hasClass("selected"))
            {
                var $element = $("#userListPageContent.allowedToManageAccountSettings").find(".addUserButton");
                if (!$element.hasClass("buttonIsDisabled"))
                {
                    $element.config = {
                        messageKey: "userlist.tips.add_users",
                        direction: OverlayTips.DIRECTION_TOP_RIGHT,
                        offsetX: 10,
                        offsetY: 0
                    };
                    if (!$("#licenseCountId").hasClass("licenseShown"))
                    {
                        $element.config.offsetX = -50;
                        $element.config.offsetY = 15;
                    }
                    return $element;
                }
            }
            var $emptyObject = $();
            $emptyObject.config = {};
            return $emptyObject;
        });

        var permissionsSelector = ".actualContent .activeButton." +
                                  (this.isPTOEnabled() || this.isSickEnabled() ?
                                   "accountTab-manageBalance-td" : "accountTab-manageAccounts-td");

        this.add(function() { return $("#userListTable").find(permissionsSelector).eqOrLast(4); }, {
            messageKey: "userlist.tips.account_section.permissions",
            direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
            offsetX: -40,
            offsetY: 5
        });

        this.add(function() { return $("#userListTable").find(".accountTab-usersForApproverSelector-td.activeButton").eqOrLast(1);}, {
            messageKey: "userlist.tips.account_section.assigned_users",
            direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
            offsetX: -50,
            offsetY: 10
        });

        this._addBalanceTips({
                                 tabCellSelector: ".actualContent .ptoTabCell",
                                 changeBalanceMessageKey: "userlist.tips.pto_section.change_balance",
                                 changeStateMessageKey: "userlist.tips.pto_section.change_state"
                             });

        this._addBalanceTips({
                                 tabCellSelector: ".actualContent .sickDaysTabCell",
                                 changeBalanceMessageKey: "userlist.tips.sick_section.change_balance",
                                 changeStateMessageKey: "userlist.tips.sick_section.change_state"
                             });


        this._addUserGroupsTips();
        this._addTipsForTabs();
    },

    _addUserGroupsTips: function()
    {
        var messageKey;
        var selector;
        var bothGroupsEnabledAndUserGroupNameIsLong = false;
        var $tabs = $("#userListPageContent.allowedToManageAccountSettings").find("#tabsPanel");

        if (this.isUserGroupsEnabled())
        {
            if (this.isTimeZoneGroupsEnabled())
            {
                selector = "#manageTimeZoneGroupsToManageDepartmentsSeparator";
                messageKey = "userlist.tips.groups";
                bothGroupsEnabledAndUserGroupNameIsLong = $tabs.find(".editDepartmentsLink").width() > 140;
            }
            else
            {
                selector = ".editDepartmentsLink";
                messageKey = "userlist.tips.groups.ugr";
            }
        }
        else
        {
            selector = ".editTimeZoneGroupsLink";
            messageKey = "userlist.tips.groups.tzg";
        }

        var $tipEl = $tabs.find(selector);
        var offsetX = 0;
        // size calculations because of wrong tips positioning on elements with absolute and relative layouts
        if ($tipEl.length != 0)
        {
            offsetX = bothGroupsEnabledAndUserGroupNameIsLong ?
                      (-$tabs.find(".editDepartmentsLink").width() - 190) :
                      -($tipEl.position().left - $tabs.position().left);
        }

        this.add(this._createGetElementIfAccountSettingSelectedFunction($tipEl) , {
            messageKey: messageKey,
            direction: bothGroupsEnabledAndUserGroupNameIsLong ? OverlayTips.DIRECTION_TOP_RIGHT : OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: offsetX,
            offsetY: 10
        });
    },

    _addBalanceTips: function(config)
    {
        this.add(function() { return $("#userListTable").find(config.tabCellSelector + ".balance-td .balanceText-span:not(:empty)").eqOrLast(1); }, {
            messageKey: config.changeBalanceMessageKey,
            direction: OverlayTips.DIRECTION_BOTTOM_LEFT,
            offsetX: -10,
            offsetY: 12
        });

        this.add(function() {
            var $accrueRule = $("#userListTable").find(config.tabCellSelector + ".accrueRule-td:not(:empty)").eqOrLast(7);
            var isDefaultRules = $accrueRule.attr("colspan") == 3;
            $accrueRule.config = {
                messageKey: "userlist.tips.balances.accrual_rules",
                direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
                offsetX: isDefaultRules ? -130 : -40,
                offsetY: 10
            };
            return $accrueRule;
        });

        this.add(function() { return $("#userListTable").find(config.tabCellSelector + ".userBalanceEnabled-td").eqOrLast(5); }, {
            messageKey: config.changeStateMessageKey,
            direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
            offsetX: -20,
            offsetY: 5
        });
    },

    _addTipsForTabs: function()
    {
        if (!(this.isPTOEnabled() || this.isSickEnabled()))
            return;

        var messageKey;
        var selector;
        var offsetX = 0;

        if (this.isPTOEnabled())
        {
            if (this.isSickEnabled())
            {
                selector = "#tabSickDaysSettings .titleSeparator";
                messageKey = "userlist.tips.tabs.balances";
            }
            else
            {
                selector = "#tabPTOSettings";
                messageKey = "userlist.tips.tabs.pto";
                offsetX = -50;
            }
        }
        else
        {
            selector = "#tabSickDaysSettings";
            messageKey = "userlist.tips.tabs.sick";
            offsetX = -50;
        }

        this.add(this._createGetElementIfAccountSettingSelectedFunction($(selector)), {
            messageKey: messageKey,
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: offsetX,
            offsetY: 15
        });
    },

    isPTOEnabled: function()
    {
        return this.config.ptoEnabled;
    },

    isSickEnabled: function()
    {
        return this.config.sickEnabled;
    },

    isUserGroupsEnabled: function()
    {
        return this.config.ugrEnabled;
    },

    isTimeZoneGroupsEnabled: function()
    {
        return this.config.tzgEnabled;
    },

    _createGetElementIfAccountSettingSelectedFunction: function($element)
    {
        return function()
        {
            var $tabAccountSettings = $("#tabAccountSettings");
            return $tabAccountSettings.length == 0 || $tabAccountSettings.hasClass("selected") ? $element : $();
        }
    }
});

export default UserListPageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/actiplans/js/tips/managers/UserListPageOverlayTipsManager.js